import { History, SearchX } from 'lucide-react';
import type { ReactElement } from 'react';

import { StatePanel } from '@/components/ui/StatePanel';

/**
 * Bitácora sin eventos (QA F1 #9): una empresa sin actividad registrada no es lo
 * mismo que un tipo o rango de fechas sin coincidencias.
 */
export function TraceEmpty({
  filtered,
  onClearFilters,
}: {
  filtered: boolean;
  onClearFilters: () => void;
}): ReactElement {
  if (filtered) {
    return (
      <StatePanel
        icon={<SearchX />}
        title="Ningún evento coincide con los filtros"
        role="status"
        className="d2"
      >
        Cambia el tipo o el rango de fechas para ver el resto de la bitácora.{' '}
        <button type="button" className="btn sm mut" onClick={onClearFilters}>
          Limpiar filtros
        </button>
      </StatePanel>
    );
  }
  return (
    <StatePanel
      icon={<History />}
      title="Todavía no hay eventos en esta empresa"
      role="status"
      className="d2"
    >
      Las acciones sobre documentos, firmas y accesos se registran a medida que ocurren.
    </StatePanel>
  );
}
